import { render } from "./TopBalance.vue?vue&type=template&id=56319426"
import script from "./TopBalance.vue?vue&type=script&lang=js"
export * from "./TopBalance.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__